import { createValidator, required } from 'util/validation'
import { DesfechoFormModel } from 'view/atendimentos/detail/soap/desfecho/DesfechoForm'

export const desfechoOdontoValidator = (isDemandaEspontanea: boolean) =>
  createValidator<DesfechoFormModel>({
    tipoAtendimento: isDemandaEspontanea && [required],
    condutasOdonto: [required],
  })
